/**
 * The highest point on an elevation profile — the first of the points at the
 * top, or null when there's no climb to speak of (fewer than two points, or
 * a flat line). Pure.
 */
export function highPointIndex(points: Array<{ x: number; y: number }> | null | undefined): number | null {
  if (!points || points.length < 2) return null;
  let best = 0;
  let min = points[0].y;
  for (let i = 1; i < points.length; i++) {
    if (points[i].y > points[best].y) best = i;
    if (points[i].y < min) min = points[i].y;
  }
  return points[best].y > min ? best : null;
}
